/*
 * Drop-Down Navigation: Responsive and Touch-Friendly
 *
 * Opens navigation items (which are visible on hover on desktop)
 * by taping for mobile
 *
 * By Osvaldas Valutis, www.osvaldas.info
 * Available for use under the MIT License
 */

const DoubleTapToGo = ((($, window, document, undefined) => {

	$.fn.doubleTapToGo = function(params) {

        if(!('ontouchstart' in window) &&
            !navigator.msMaxTouchPoints &&
            !navigator.userAgent.toLowerCase().match( /windows phone os 7/i )) {

            return false;
        }

        this.each( function() {

            let curItem = false;

            $(this).on('click', function(e) {

                const item = $(this);

                if(item[0] !== curItem[0]) {
                    e.preventDefault();
                    curItem = item;
                }
            });

            $(document).on('click touchstart MSPointerDown', e => {
                let resetItem = true;
                const parents   = $(e.target).parents();

                for (let i = 0; i < parents.length; i++) {

                    if (parents[i] === curItem[0]) {
                        resetItem = false;
                    }
                }

                if (resetItem) {
                    curItem = false;
                }
            });
        });

        return this;
    };
}))( jQuery, window, document );

export default DoubleTapToGo;
